import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import Modal from '../../../common/Modal'
import ButtonLink from '../../../common/buttons/ButtonLink'

import classes from './LockedMemberModal.module.scss'

const LockedMemberModal = ({ member, membership, communityId, onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal isOpen onClose={onClose} className={classes.modal}>
      <h2 className={classes.title}>
        {t('dashboard.student.accountTab.lockedMember.title', { name: `${member.first_name} ${member.last_name}` })}
      </h2>
      <p className={classes.seats}>
        {membership
          ? t('dashboard.student.accountTab.lockedMember.seats', {
            tier: t(`programs.registration.membershipPlan.tiers.${membership.tier}`),
            used: membership.seatsUsed,
            count: membership.seatsTotal,
          })
          : t('dashboard.student.accountTab.lockedMember.noMembership')}
      </p>
      <ButtonLink navigateTo={`/landing/${communityId}`}>
        {t('dashboard.student.accountTab.membership.joinProgram')}
      </ButtonLink>
      <Link to={`/profile/${member.id}`} className={classes.seeProfile}>
        {t('dashboard.student.accountTab.lockedMember.seeProfile')}
      </Link>
    </Modal>
  )
}

LockedMemberModal.propTypes = {
  member: PropTypes.shape({
    id: PropTypes.number,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }).isRequired,
  membership: PropTypes.shape({
    tier: PropTypes.string,
    seatsUsed: PropTypes.number,
    seatsTotal: PropTypes.number,
  }),
  communityId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default LockedMemberModal
